import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import _str from "shared/util/_str";

import "./index.scss";

// HoF to prevent default on an event.
const preventDefault = (callback) => {
	return (event) => {
		event.preventDefault();

		if (callback) {
			callback();
		}
	};
};

const LoadingError = ({ className, title, message, onReload, show }) => show && (
	<button className={classnames("loadingError", className)} onClick={preventDefault(onReload)}>
		<span className="okicon i-refresh" />
		<div className="loadingError-title">{title}</div>
		<div className="loadingError-message">{message}</div>
	</button>
);
LoadingError.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	message: PropTypes.string,
	onReload: PropTypes.func,
	show: PropTypes.bool,
};
LoadingError.defaultProps = {
	className: undefined,
	title: _str("It's not you, it's us."),
	message: _str("We're having trouble reaching our servers. Please try again."),
	onReload: null,
	show: false,
};

export default LoadingError;



// WEBPACK FOOTER //
// ./src/shared/components/LoadingError/index.jsx